import { FormPackType } from '@upstart/harmony/lib/constants';
import {
  ONLINE_FORM_PACK_LOOKUP,
  PROTECTION_PLANS_DESCRIPTION,
} from '../../containers/OnlineFormPack/constants';

export const newFormPackSchema = {
  title: 'Form Pack',
  type: 'object',
  required: ['name'],
  properties: {
    name: { type: 'string', title: 'Name' },
    dealer_id: { type: 'string' },
  },
};

// Get description text, which varies per type of pack.
const getDescription = (formPack) => {
  const key = formPack.id.substring(formPack.dealer_id.length + 1);
  if (key in ONLINE_FORM_PACK_LOOKUP) {
    const { description } = ONLINE_FORM_PACK_LOOKUP[key];
    return description;
  }
  // If its not in the lookup object its a protection plan
  return PROTECTION_PLANS_DESCRIPTION;
};

// FormPack is an optional parameter passed for Online Form Packs
export const getFormPackSchema = (formPack, forms, type) => ({
  title: type === FormPackType.ONLINE ? formPack.name : 'Form Pack',
  description:
    type === FormPackType.ONLINE ? getDescription(formPack) : undefined,
  type: 'object',
  required: ['name', 'dealer_id'],
  properties: {
    name: { type: 'string', title: 'Name' },
    forms: {
      type: 'array',
      title: 'Forms',
      items: {
        type: 'string',
        enum: forms.map((f) => f.id),
        enumNames: forms.map((f) => f.name),
      },
      uniqueItems: true,
    },
    dealer_id: { type: 'string' },
  },
});

export const getUiSchema = (type) => ({
  // Can only change name for In-Store form packs
  name: { 'ui:widget': type === FormPackType.ONLINE ? 'hidden' : undefined },
  dealer_id: { 'ui:widget': 'hidden' },
  forms: {
    'ui:widget': 'checkboxes',
    classNames: 'col-md-12',
  },
});
